import { HttpContextToken } from '@angular/common/http';

export const AUTH_REQUIRED = new HttpContextToken<boolean>(() => false);
